import React, { Component } from "react";
import * as Colors from "../../utils/Color";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { Field } from "react-form";
import { validate } from "../../utils/validation";

const styles = {
  menuItemStyle: {
    padding: "8px 0"
  },
  floatingLabelStyle: {
    fontWeight: "bold",
    color: Colors.grey50
  },
  underlineStyle: {
    borderColor: Colors.grey
  },
  iconStyle: {
    fill: Colors.grey50
  },
  selectedMenuItemStyle: {
    color: "rgba(0, 0, 0, 0.87)",
    fontWeight: "700"
  }
};

class SelectMenu extends Component {
  state = {
    value: this.props.defaultValue
  };

  componentDidMount() {
    if (
      (this.props.defaultValue || this.props.defaultValue === 0) &&
      this.props.formApi
    ) {
      this.props.formApi.setValue(this.props.field, this.props.defaultValue);
    }
  }

  render() {
    let validation = {validate: value => validate(value, ["required"])};

    if(this.props.label === "Agreed Zon") {
        validation = null;
    }
    return (
      <Field
          {...validation}
        field={this.props.field}
      >
        {fieldApi => {
          const { setValue, error } = fieldApi;
          return (
            <SelectField
              onChange={(e, k, value) => {
                setValue(value);
                this.setState({ value });
              }}
              value={this.state.value}
              floatingLabelText={this.props.label}
              menuItemStyle={styles.menuItemStyle}
              underlineStyle={styles.underlineStyle}
              underlineFocusStyle={styles.underlineStyle}
              iconStyle={styles.iconStyle}
              floatingLabelStyle={styles.floatingLabelStyle}
              fullWidth={true}
              selectedMenuItemStyle={styles.selectedMenuItemStyle}
              errorText={error}
            >
              {this.props.menu.map(item => (
                <MenuItem
                  key={item.value}
                  value={item.value}
                  primaryText={item.key}
                />
              ))}
            </SelectField>
          );
        }}
      </Field>
    );
  }
}

export default SelectMenu;



// WEBPACK FOOTER //
// ./src/components/UI/Select.js